import React from 'react';
import { Planet1, Star1, Planet2 } from '@plug/ui/icons';
import { PositionedElement } from './styles';
import UpDownAnimation from '@plug/components/animations/up-down-animation';
import PulseAnimation from '@plug/components/animations/pulse-animation';

const BgLeftContainer: React.FC = (): JSX.Element => {
  return (
    <>
      <PositionedElement top="142px" left="3px">
        <UpDownAnimation>
          <Planet1 />
        </UpDownAnimation>
      </PositionedElement>

      <PositionedElement top="140px" right="120px">
        <PulseAnimation>
          <Star1 />
        </PulseAnimation>
      </PositionedElement>

      <PositionedElement top="604px" left="116px">
        <PulseAnimation>
          <Star1 width={25} height={24} />
        </PulseAnimation>
      </PositionedElement>

      <PositionedElement top="510px" right="41.95px">
        <UpDownAnimation>
          <Planet2 />
        </UpDownAnimation>
      </PositionedElement>
    </>
  );
};

export default BgLeftContainer;
